var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertPanel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#333333;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#333333;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h24v24H0V0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.9,20H5.1c-0.4,0-0.7-0.1-1-0.3c-0.3-0.2-0.6-0.4-0.8-0.8c-0.2-0.3-0.3-0.7-0.3-1c0-0.4,0.1-0.7,0.3-1 L10.2,5c0.2-0.3,0.4-0.6,0.8-0.7C11.3,4.1,11.6,4,12,4c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.6,0.4,0.8,0.7l6.9,11.9 c0.2,0.3,0.3,0.7,0.3,1c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.4,0.6-0.8,0.8C19.6,19.9,19.3,20,18.9,20z M11.1,5.5L4.1,17.4 C4,17.5,4,17.7,4,17.9c0,0.2,0,0.4,0.1,0.6c0.1,0.2,0.2,0.3,0.4,0.4C4.7,19,4.9,19,5.1,19h13.8c0.2,0,0.4,0,0.5-0.1 c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.2,0.1-0.3,0.1-0.5c0-0.2,0-0.4-0.1-0.5L12.9,5.5c-0.1-0.2-0.2-0.3-0.4-0.4C12.4,5,12.2,5,12,5 c-0.2,0-0.4,0-0.5,0.1C11.3,5.2,11.2,5.4,11.1,5.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11,16c0-0.3,0.1-0.5,0.3-0.7c0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7 c0,0.3-0.1,0.5-0.3,0.7C12.5,16.9,12.3,17,12,17c-0.3,0-0.5-0.1-0.7-0.3C11.1,16.5,11,16.3,11,16z M11,10c0-0.3,0.1-0.5,0.3-0.7 C11.5,9.1,11.7,9,12,9c0.3,0,0.5,0.1,0.7,0.3C12.9,9.5,13,9.7,13,10v3c0,0.3-0.1,0.5-0.3,0.7C12.5,13.9,12.3,14,12,14 c-0.3,0-0.5-0.1-0.7-0.3C11.1,13.5,11,13.3,11,13V10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPanel);
export default __webpack_public_path__ + "static/media/alert-panel.20cc7245539df94e8bab266695ff03b2.svg";
export { ForwardRef as ReactComponent };